import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ScheduleService } from '../schedule/schedule.service';
import { faEdit } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-editable-textarea',
  templateUrl: './editable-textarea.component.html',
  styleUrls: ['./editable-textarea.component.scss']
})
export class EditableTextareaComponent implements OnInit {

  @Input() data: any;
  @Output() focusOut: EventEmitter<any> = new EventEmitter<any>();
  //currency = '$';
  faedit = faEdit;
  editMode = false;
  constructor(public scheduleService: ScheduleService) {}

  ngOnInit() {}

  onFocusOut(event) {
    
    //update view
    this.focusOut.emit(this.data);
    // save updated notes to DB 

/*
    this.scheduleService.updateJobNotes(this.data).subscribe(
      res => {
      }, err => {
      });

    */

  }

}
